if (!customElements.get('shop-all-mega-menu')) {
  customElements.define('shop-all-mega-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.shop-all-mega-menu__panel');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.closeTimer = null;
      this.addEventListener('mouseenter', () => this.open());
      this.addEventListener('mouseleave', () => this.scheduleClose());
      this.addEventListener('focusin', () => this.open());
      this.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) this.close();
      }));
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.summary.addEventListener('click', () => requestAnimationFrame(() => this.syncExpanded()));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
      window.addEventListener('resize', () => this.syncPosition(), { passive: true });
    }

    open() {
      if (!this.desktop.matches) return;
      window.clearTimeout(this.closeTimer);
      document.querySelectorAll('.header__inline-menu details[open]').forEach((details) => {
        if (details !== this.details) details.removeAttribute('open');
      });
      this.syncPosition();
      this.details.open = true;
      this.syncExpanded();
    }

    scheduleClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.close(), 150);
    }

    close() {
      window.clearTimeout(this.closeTimer);
      this.details.removeAttribute('open');
      this.syncExpanded();
    }

    syncPosition() {
      if (!this.desktop.matches) return;
      this.style.setProperty('--shop-mega-left', `${-Math.round(this.details.getBoundingClientRect().left)}px`);
    }

    syncExpanded() {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.summary.focus();
      } else if (event.key === 'ArrowDown' && event.target === this.summary) {
        event.preventDefault();
        this.open();
        this.panel.querySelector('a')?.focus();
      }
    }
  });
}
